import {FC,} from "react";
import {Route} from "react-router-dom";
import {Navigate, Routes} from "react-router";
import {MembersTradesPage} from "./Trades";
import {MembersNoticeMngPage} from "./NoticeMng";
import {MembersDepositPage} from "./Deposit";
import {MembersFCBankPage} from "./FCBank";
import {MembersWithdrawPage} from "backoffice/ui/Pages/Members/Withdraw";


export const MembersPage: FC = () => {
  return (
      <Routes>
        <Route path="deposit/*" element={<MembersDepositPage/>}/>
        <Route path="fcbank/*" element={<MembersFCBankPage/>}/>
        <Route path="noticemng/*" element={<MembersNoticeMngPage/>}/>
        <Route path="trades/*" element={<MembersTradesPage/>}/>
        <Route path="withdraw/*" element={<MembersWithdrawPage/>}/>
        <Route path="*" element={<Navigate to="/" replace/>}/>
      </Routes>
  );
}


